export default function UserIcon(
  props: Readonly<React.SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.0001 8.33268C11.841 8.33268 13.3334 6.8403 13.3334 4.99935C13.3334 3.1584 11.841 1.66602 10.0001 1.66602C8.15913 1.66602 6.66675 3.1584 6.66675 4.99935C6.66675 6.8403 8.15913 8.33268 10.0001 8.33268Z"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
      <path
        d="M16.6663 14.584C16.6663 16.6551 16.6663 18.334 9.99967 18.334C3.33301 18.334 3.33301 16.6551 3.33301 14.584C3.33301 12.5129 6.31777 10.834 9.99967 10.834C13.6816 10.834 16.6663 12.5129 16.6663 14.584Z"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
    </svg>
  );
}
